import { DateTime } from "luxon"
import useSWR from 'swr'

import { maskCurrency } from "../../../utils/utils"
import { api } from "../../../api/api"

export function OrdersByCustomers({ id, clear }) {
  const { data, isLoading } = useSWR(`/orders/list/${id}`, async () => {
    const response = await api.get('/orders/list/' + id)
    const { data } = response.data
    return data
  })

  return (
    <div className="modal fade admin-form-modal customer-orders-modal" id="modalOrdersByCustomer" tabIndex="-1" data-bs-backdrop="static" aria-labelledby="modalOrdersByCustomerLabel" aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered modal-xl">
        <div className="modal-content">
          <div className="modal-header">
            <h6 className="modal-title" id="modalOrdersByCustomerLabel">Histórico do cliente <span>{data?.length ? `· ${data[0]?.phone}` : ''}</span></h6>
            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={() => clear()}></button>
          </div>
          <div className="modal-body">
            <div>
              {isLoading && (
                <div className="d-flex justify-content-center align-items-center">
                  <div className="spinner-border " role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              )}
              {data && (
                <div className="admin-table-wrap">
                  <table className="admin-table">
                    <thead>
                      <tr>
                        <th >Nº Pedido</th>
                        <th >Data</th>
                        <th >Cliente</th>
                        <th >Status</th>
                        <th >Valor</th>
                        <th >Frete</th>
                        <th >Meio de pagamento</th>
                      </tr>
                    </thead>
                    <tbody>
                      {data?.map((order) => {
                        return (
                          <tr key={order.id}>
                            <td data-label="Pedido">#{String(order?.numOrder)?.padStart(6, '0')}</td>
                            <td data-label="Data">{DateTime.fromISO(order.createdAt).plus({ hours: -3 }).toFormat("dd/MM/yyyy HH:mm")}</td>
                            <td data-label="Cliente">{order.name}</td>
                            <td data-label="Status">
                              {String(order.status[0].toUpperCase()) + order.status?.substr(1)}
                            </td>
                            <td data-label="Valor">{maskCurrency(order.total)}</td>
                            <td data-label="Frete">{maskCurrency(order?.deliveryDistrict?.pricing ?? 0)}</td>
                            <td data-label="Pagamento">{order.paymentMethod}</td>
                          </tr>
                        )
                      })}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
